import { Typography } from '@branchjs/neo-components';
import classNames from 'classnames';
import React from 'react';
import { NoResultsStyles } from './NoResults.styles';

type Props = {
  className?: string;
  description?: string;
  headline?: string;
  imagePath?: string;
  id?: string;
  noBackground?: boolean;
};

export const NoResults = ({ className, description, headline, id, imagePath, noBackground }: Props) => {
  return (
    <div className={classNames(className, NoResultsStyles.container, { noBackground })} id={id}>
      <div className={NoResultsStyles.contentContainer}>
        <img alt="Search" src={imagePath || '/static/images/ad_partner_manager/search.svg'} height={116} />
        <Typography className={NoResultsStyles.title} variant="h3">
          {headline || 'There are no results for your inquiry.'}
        </Typography>
        <Typography className={NoResultsStyles.description} variant="body1">
          {description || 'Please edit your search and try again.'}
        </Typography>
      </div>
    </div>
  );
};

export default NoResults;
